import { render } from "./resourcesList.vue?vue&type=template&id=0f3fb1d1&scoped=true"
import script from "./resourcesList.vue?vue&type=script&lang=js"
export * from "./resourcesList.vue?vue&type=script&lang=js"

import "./resourcesList.vue?vue&type=style&index=0&id=0f3fb1d1&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3fb1d1"]])

export default __exports__